export const ERROR_NODE_HEIGHT = 16;
